// Import: Middleware Action & Custom Types
import {
  CLEAN_PRE_REGISTER_GIFT_SIM_IPB,
  CLEAN_PRE_REGISTER_GIFT_SIM_IPB_ERROR,
} from '_models/redux/types';

// Action function
export const cleanPreRegisterGiftSimDalefon = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      type: CLEAN_PRE_REGISTER_GIFT_SIM_IPB,
      payload: undefined,
    });
  } catch (e) {
    dispatch({
      type: CLEAN_PRE_REGISTER_GIFT_SIM_IPB_ERROR,
      payload: undefined,
    });
  }
};
